import { motion } from "framer-motion";
import im from "./img/51.jpg";
import im2 from "./img/52.jpg";
import AOD from "../images/5_20240211_114110_0004.jpg";
import GOD from "../images/papa (6).jpg";

const Leader = () => {
  const contentBlocks = [
    {
      image: GOD,
      imageAlt: "Leader Olumba Olumba Obu profile",
      overlayImage: im,
      overlayAlt: "Leader banner portrait",
      paragraphs: [
        "Leader Olumba Olumba Obu is honored as the Sole Spiritual Head of the Universe, the founder of the Brotherhood of the Cross and Star, and the sustaining authority of the Kingdom.",
        "His directives shape policy, doctrine, and spiritual administration, providing a unified path for the well-being and growth of the fold.",
      ],
    },
    {
      image: AOD,
      imageAlt: "Leader ministry documentation",
      overlayImage: im2,
      overlayAlt: "Early mission work placeholder",
      paragraphs: [
        "From early childhood, his ministry reflected instruction, compassion, healing, and service, establishing a model of practical spirituality rooted in love and humility.",
        "His witness drew diverse communities, inspired moral renewal, and strengthened the spiritual confidence of those who encountered his teachings.",
      ],
    },
    {
      image: im2,
      imageAlt: "Leader historical ministry scenes",
      overlayImage: im,
      overlayAlt: "Kingdom expansion placeholder",
      paragraphs: [
        "His full-time ministry catalyzed the first congregation of the Brotherhood, beginning with prayer gatherings that expanded rapidly through authentic testimony and spiritual impact.",
        "This growth led to successive movement into larger spaces and eventually to the World Headquarters at 34 Ambo Street, Calabar, where the Kingdom mission continues to advance.",
      ],
    },
  ];

  return (
    <motion.main
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{
        duration: 1.1,
        delay: 0.2,
        ease: [0, 0.71, 0.2, 1.01],
      }}
      className="relative z-0 w-full bg-white text-slate-900"
    >
      <header className="relative z-0 pt-24 mt-24 md:pt-32 px-6 md:px-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[20px] h-[20px] rounded-full bg-blue-200/40 blur-[10px]" />
          <div className="absolute bottom-0 left-1/4 w-[10px] h-[10px] rounded-full bg-blue-100/50 blur-[10px]" />
          <div className="absolute bottom-0 right-1/4 w-[10px] h-[10px] rounded-full bg-indigo-100/50 blur-[10px]" />
        </div>

        <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="inline-flex items-center gap-4"
          ></motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="space-y-4"
          >
            <h1 className="text-5xl md:text-7xl font-black text-stone-900 tracking-tighter leading-none uppercase">
              Leader{" "}
              <span className="text-red-600 italic">Olumba Olumba Obu</span>
            </h1>
            <p className="text-stone-500 text-base md:text-xl font-medium leading-relaxed max-w-3xl mx-auto">
              The Sole Spiritual Head of the Universe <br />
            </p>
            <p className="text-stone-500 text-base md:text-lg max-w-3xl mx-auto">
              Founder and Sustainer of the Brotherhood of the Cross and Star
            </p>
          </motion.div>
        </div>
      </header>

      <section className="px-6 md:px-20 py-16 md:py-28 space-y-28">
        {contentBlocks.map((block, index) => {
          const isOdd = index % 2 !== 0;
          const overlayAlignmentClass = isOdd ? "-left-10" : "-right-10";

          return (
            <article
              key={block.title}
              className="grid md:grid-cols-2 gap-14 md:gap-24 items-center"
            >
              <div className={isOdd ? "md:order-2" : ""}>
                <div className="relative">
                  <img
                    src={block.image}
                    alt={block.imageAlt}
                    className="w-full h-[300px] md:h-[420px] object-cover border border-slate-300"
                  />
                  <img
                    src={block.overlayImage}
                    alt={block.overlayAlt}
                    className={`hidden md:block absolute -bottom-10 ${overlayAlignmentClass} w-[46%] h-[180px] object-cover border-4 border-white shadow-xl`}
                  />
                </div>
              </div>

              <div className={`${isOdd ? "md:order-1" : ""} md:px-6 lg:px-10`}>
                <h2 className="text-2xl md:text-4xl leading-tight font-semibold text-slate-900">
                  {block.title}
                </h2>
                <div className="mt-6 space-y-4 text-base md:text-lg leading-relaxed text-slate-700">
                  {block.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </article>
          );
        })}
      </section>
    </motion.main>
  );
};

export default Leader;
